<template>
  <div>
    <!--  -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        //
      }
    },
    created() {
      this.$global.axios.post(this, '/sywl/api/pay/recharge', {
        price: this.$route.query.price,
        payType: '3'
      }, res => {
        document.querySelector('body').innerHTML = res.data;

         document.forms[0].submit();
      })
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/pay/index.vue